// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAIOHeR_swKGv4-MiOQVqyju7HRBh9HhQo",
  authDomain: "twitter-clone-f91f3.firebaseapp.com",
  projectId: "twitter-clone-f91f3",
  storageBucket: "twitter-clone-f91f3.appspot.com",
  messagingSenderId: "945309709073",
  appId: "1:945309709073:web:30d22cdef743aeae3e92b0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;